// Import model
import { DataviewExternalLinkResponse } from '../models/DataviewExternalLinkResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { ExternalLink } from '../models/ExternalLink';
import { FilterExternalLinkRequest } from '../models/FilterExternalLinkRequest';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { ExternalLinkSerializer } from './ExternalLinkSerializer';
import { FilterExternalLinkRequestSerializer } from './FilterExternalLinkRequestSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewExternalLinkResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewExternalLinkResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewExternalLinkResponse instance
   */
  static deserialize(json: string): DataviewExternalLinkResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewExternalLinkResponse instance
   */
  static fromObject(obj: any): DataviewExternalLinkResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewExternalLinkResponse');
    }


    const instance: DataviewExternalLinkResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        ExternalLinkSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterExternalLinkRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewExternalLinkResponse instances
   */
  static deserializeArray(json: string): DataviewExternalLinkResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewExternalLinkResponse instance to a JSON string
   */
  static serialize(instance: DataviewExternalLinkResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewExternalLinkResponse instance to a plain object
   */
  static toObject(instance: DataviewExternalLinkResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        ExternalLinkSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterExternalLinkRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewExternalLinkResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewExternalLinkResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
